import { gql } from "@apollo/client";
import { HOUSING_FCFS_AVAILABILITY_MANAGER_QF } from "PropertyManagement/gqlFragments";
import { getFragmentName } from "utils/query";

export const DOCUMENTS_FIELDS_FRAGMENT = gql`
  fragment BuldingDocumentsFieldsV2 on AppDocument {
    id
    name
    category
    fileUrl
    __typename
  }
`;

export const HOUSING_WAITLIST_QF = gql`
  fragment HousingWaitlistFieldsV2 on HousingWaitlist {
    openDate
    closeDate
    status
    statusIsGlobal
    units {
      unitType
      status
      openDate
      closeDate
    }
    __typename
  }
`;

export const BUILDING_UNIT_GROUP_QF = gql`
  fragment BuildingUnitGroupFieldsV2 on BuildingUnitGroup {
    id
    deleted
    unitType
    unitCount
    fcfsUnitCount
    fcfsUnitCount
    bathroomCount
    mobilityAccessible
    visionAccessible
    hearingAccessible
    rentType
    ami
    minIncome
    rentalCost
    maxIncomes {
      id
      householdSize
      maxIncome
    }
    __typename
  }
`;

export const HOUSING_LOTTERY_QF = gql`
  fragment HousingLotteryFieldsV2 on HousingLottery {
    id
    startDate
    endDate
    details
    contactName
    contactEmail
    contactPhone
    url
    waitlistStatus
    documents {
      ...BuldingDocumentsFieldsV2
    }
    __typename
  }
  ${DOCUMENTS_FIELDS_FRAGMENT}
`;

export const BUILDING_FIELDS_FRAGMENT = gql`
  fragment BuildingGeneralFieldsV2 on BuildingInterface {
    id
    slug
    name
    projectId
    housingType
    address {
      street1
      city
      state
      zipCode
    }
    availability {
      status
      bedrooms
      units {
        ...${getFragmentName(BUILDING_UNIT_GROUP_QF)}
      }
    }
    description
    accessibilityDetails
    additionalDetails
    amenities
    amenitiesDetails
    includedUtilities
    utilitiesIncluded
    petPolicy
    petFriendly
    contactName
    contactPhone
    contactEmail
    url
    applicationUrl
    documents {
      ...BuldingDocumentsFieldsV2
    }
    geocode {
      id
      latitude
      longitude
      formattedAddress
    }
    unitGroups {
      ...${getFragmentName(BUILDING_UNIT_GROUP_QF)}
    }
    units {
      deeplyAffordable
      totals {
        units
        accessible
        affordable
      }
      availability {
        bedrooms
        available
        accessible
      }
    }
    featured {
      id
      url
      location
      caption
      bannerUrl
    }
    images {
      id
      name
      caption
      location
      url
      thumbnailUrl
      lightboxUrl
    }
    housingLottery {
      ...HousingLotteryFieldsV2
    }
    housingWaitlist {
      ...${getFragmentName(HOUSING_WAITLIST_QF)}
    }
    housingVacancy {
      ...HousingVacancyManagerFieldsV2
    }
    ageRestrictionType
    ageRestrictionDetail
    ageRestrictionOrDisabled
    ageRestrictionSize
    closedReferralType
    closedReferralCount
    preferences
    housingSetAsides {
      type
      details
      unitCount
    }
    __typename
  }
  ${DOCUMENTS_FIELDS_FRAGMENT}
  ${HOUSING_WAITLIST_QF}
  ${HOUSING_LOTTERY_QF}
  ${HOUSING_FCFS_AVAILABILITY_MANAGER_QF}
  ${BUILDING_UNIT_GROUP_QF}
`;

export default BUILDING_FIELDS_FRAGMENT;
